import {
  ADDRESS_COPIED,
  FAILED_COPY_ADDRESS,
  INVALID_FILE,
} from "../../constants/strings";
import { omitNilValues } from "../../utils/object";
import { replaceLinebreak } from "../../utils/string";
import { VAULT_DOCUMENT_FILENAME } from "../../models/validators/regex";

export const copyTextToClipboard = (snackbar, onClickCopyAddress) => text => {
  onClickCopyAddress && onClickCopyAddress();

  navigator.clipboard
    .writeText(text)
    .then(() => snackbar.showSuccess({ message: ADDRESS_COPIED }))
    .catch(() =>
      snackbar.showAlert({
        message: FAILED_COPY_ADDRESS,
      })
    );
};

export const createEditParcelPayload = values => {
  const filledValues = omitNilValues(values);
  if (filledValues.instructions) {
    filledValues.instructions = replaceLinebreak(filledValues.instructions);
  }
  return filledValues;
};

export const convertFileToBase64 = file => {
  return new Promise((resolve, reject) => {
    if (!file || !(file instanceof File || file instanceof Blob)) {
      reject(new Error(INVALID_FILE));
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove the data URL prefix (e.g., "data:image/jpeg;base64,")
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = error => reject(error);
  });
};

export const findDocumentTypeByCode = (vaultDocumentData, selectedCode) => {
  if (
    !vaultDocumentData ||
    typeof vaultDocumentData !== "object" ||
    !selectedCode
  ) {
    return null;
  }

  for (const documentTypeName in vaultDocumentData) {
    const documentTypeObj = vaultDocumentData[documentTypeName];
    if (documentTypeObj.code === selectedCode) {
      return {
        ...documentTypeObj,
        fileTypes: Object.keys(documentTypeObj.dims || {}),
      };
    }
  }

  return null;
};

export const isDocumentTypeUploaded = (
  vaultDocumentKey,
  selectedDocumentType
) => {
  if (!vaultDocumentKey || !vaultDocumentKey.length || !selectedDocumentType) {
    return false;
  }

  const existingDocumentTypes = vaultDocumentKey
    .map(key => {
      //NOTE: Extract the document type (last part after the second '*', example key="99996129103635*20250818*COI")
      const parts = key.split("*");
      return parts.length >= 3 ? parts[2] : null;
    })
    .filter(Boolean);

  return existingDocumentTypes.includes(selectedDocumentType);
};

// Function to check real PDF file type by magic bytes
export const isRealPdfFile = async file => {
  if (!file || !(file instanceof File)) {
    return false;
  }

  try {
    // Read first 8 bytes of the file to check PDF signature
    const arrayBuffer = await file.slice(0, 8).arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    // PDF files start with "%PDF-" (25 50 44 46 2D in hex)
    const pdfSignature = [0x25, 0x50, 0x44, 0x46, 0x2d]; // %PDF-

    // Check if first 5 bytes match PDF signature
    for (let i = 0; i < pdfSignature.length; i++) {
      if (uint8Array[i] !== pdfSignature[i]) {
        return false;
      }
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const getVaultFilename = (
  contentDisposition,
  fallbackFilename = "download"
) => {
  if (!contentDisposition) {
    return fallbackFilename;
  }

  const filenameMatch = contentDisposition.match(VAULT_DOCUMENT_FILENAME);

  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].replace(/['"]/g, "");
  }

  return fallbackFilename;
};
